<template>
    <HeaderComponent />
    <router-view></router-view>
    <FooterComponent />
</template>

<script>
import HeaderComponent from './HeaderComponent.vue'
import FooterComponent from './FooterComponent.vue'

export default {
    name: 'MainLayout',
    components: {
        HeaderComponent,
        FooterComponent
    }
}
</script>

<style scoped>
.main-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.content {
    flex: 1;
    margin-top: 80px;
    /* 给header留出空间 */
    padding: 20px;
}
</style>
